import { useEffect, useState } from 'react';
import { UserRoundX } from 'lucide-react';
import { api } from './api';
import { text, type Locale } from '../shared/content';
export default function BlockedResidents({
  locale,
  onAction,
}: {
  locale: Locale;
  onAction: (type: string, payload: Record<string, unknown>) => Promise<unknown>;
}) {
  const title = text('Blocked residents', '已屏蔽居民', '已封鎖居民', 'Vecinos bloqueados')[locale],
    unblock = text('Unblock', '取消屏蔽', '解除封鎖', 'Desbloquear')[locale];
  const [rows, setRows] = useState<{ id: string; name: string }[]>([]),
    [visible, setVisible] = useState(20),
    [busy, setBusy] = useState(false);
  useEffect(() => {
    let alive = true;
    api('/blocks')
      .then((data) => {
        if (alive) setRows(data.blocks);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);
  if (!rows.length) return null;
  return (
    <section className="blocked-residents">
      <h3>{title}</h3>
      {rows.slice(0, visible).map((row) => (
        <div className="friend-row" key={row.id}>
          <UserRoundX size={15} />
          <strong>{row.name}</strong>
          <button
            className="text-button"
            disabled={busy}
            onClick={async () => {
              setBusy(true);
              try {
                const result = await onAction('unblock', { targetId: row.id });
                if (result) setRows((await api('/blocks')).blocks);
              } finally {
                setBusy(false);
              }
            }}
          >
            {unblock}
          </button>
        </div>
      ))}
      {rows.length > visible && (
        <button className="text-button" onClick={() => setVisible((n) => n + 20)}>
          +20
        </button>
      )}
    </section>
  );
}
